export default __webpack_public_path__ + "static/media/Business Center- Keyboard.01499c65.jpg";